<div class="tab" [class.backup]="this.isBackupServer" [class.staging]="this.isStagingServer">

  <div (click)="onSortLayouts()" class="button">
    <i class="fas fa-sort-amount-up fa-lg clickable"></i>
  </div>

  <ng-container *ngFor="let tab of tabs">
    <div [ngClass]="{'active': tab.isActive}" class="button">
      <span (click)="selectTab(tab)"
            (dblclick)="onTabHeaderDoubleClick(tab)"
            *ngIf="!tab.isEditMode"
            class="header clickable">
        {{tab.header}}
      </span>
      <i (click)="closeTab(tab)"
         *ngIf="tab.isActive && !tab.isEditMode && securityContext.canCloseLayout"
         class="fas fa-times-circle close-icon"
      ></i>
      <dx-text-box (onBlur)="onFocusLost(tab)"
                   (onEnterKey)="setTabHeader(tab)"
                   (onKeyUp)="onTabKeyUp($event, tab)"
                   [(value)]="tab.proposedHeader"
                   [visible]="tab.isEditMode"
                   style="margin-top: -4px"
      ></dx-text-box>
    </div>
  </ng-container>

  <div (click)="addTab()" [ngClass]="{'ets-hidden': !securityContext.canAddLayout}" class="button">
    <i class="fas fa-plus-square fa-lg add-icon clickable"></i>
  </div>

  <button
    (click)="this.toggleFullscreen()"
    [title]="this.isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
    [attr.aria-label]="this.isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
    class="fullscreen-toggle"
    type="button"
  >
    <svg *ngIf="!this.isFullscreen" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 4 h6 M4 4 v6 M20 4 h-6 M20 4 v6 M4 20 h6 M4 20 v-6 M20 20 h-6 M20 20 v-6"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <svg *ngIf="this.isFullscreen" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 4 L10 10 M10 10 L10 6 M10 10 L6 10 M20 4 L14 10 M14 10 L14 6 M14 10 L18 10 M4 20 L10 14 M10 14 L10 18 M10 14 L6 14 M20 20 L14 14 M14 14 L14 18 M14 14 L18 14"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div *ngIf="!this.isEtsHost" class="menu">
    <div class="btn telegram"><ets-telegram-connections></ets-telegram-connections></div>
    
    <div class="btn" *ngIf="this.securityContext.quoteGenerator">
      <ets-quote-generator-component></ets-quote-generator-component>
    </div>
    
    
    <div class="btn">
      <ets-host-menu [uniqueId]="'layout-tabs-host-menu'"></ets-host-menu>
    </div>
    
    
    <div class="btn pivots" *ngIf="this.securityContext.pivotsTrackerButton">
      <ets-pivot-points-popup></ets-pivot-points-popup>
    </div>
    
    
    <div class="btn resources" *ngIf="this.securityContext.resourceButton">
      <ets-resource-menu></ets-resource-menu>
    </div>
    
  </div>

</div>
